import {combineReducers} from 'redux';
import AuthReducer from './AuthReducer';
import UserReducer from './UserReducer';
import RoleReducer from './RoleReducer';
import IssueReducer from './IssueReducer';

const rootReducer = combineReducers({
    authReducer: AuthReducer,
    userReducer: UserReducer,
    roleReducer: RoleReducer,
    issueReducer: IssueReducer
})

export default rootReducer;
